export const API_SIGN_IN = "/authentication/sign-in";
export const API_LOGOUT = "/authentication/logout";
export const API_VERIFY_TOKEN = "/authentication/verify";
export const API_REFRESH_TOKEN = "/authentication/refresh";

export const API_SIGN_UP = "/authentication/sign-up";
export const API_REGISTER = "/authentication/register";

export const API_GET_SELECT_OPTIONS = "api/v1/services/select-options";
export const API_GET_INSPECTION_DETAILS = "api/v1/inspection/details";

export const API_MY_PAGE_SETTING = "/api/v1/settings/page/my-page";
export const API_MY_PAGE = "api/v1/my-page";
export const API_READ_NOTICATION = "api/v1/my-page/read-notification";
export const API_READ_NOTICATIONS = "api/v1/my-page/read-notifications";

export const API_GET_PAGE_TENKEN_TOP = "/api/v1/settings/page/tenken-top";
export const API_GET_MASTER_TOP = "/api/v1/settings/page/master-top";
export const API_CHANGE_PASSWORD_SIDEBAR =
  "api/v1/settings/page/change-password";
export const API_CHANGE_PASSWORD = "api/v1/users/change-password";
export const API_GET_SETTING_PAGE = "/api/v1/settings/page/setting";
export const API_GET_INSPECTION_STATUS_PAGE_SETTING =
  "/api/v1/settings/page/inspection-status";
export const API_GET_JUDGMENT_PAGE = "/api/v1/settings/page/judgment";

export const API_GET_JUDGMENT_LIST = "/api/v1/judgment/list";
export const API_POST_JUDGMENT = "/api/v1/judgment/judge";
export const API_APPROVE_ALL = "/api/v1/judgment/approve-all";


export const API_SEARCH_LOG_USER = "api/v1/users/logs";
export const API_DOWNLOAD_LOG_USER = "api/v1/users/download-log";
export const API_USER_MASTER_IMPORT = "api/v1/users/import";
export const API_USER_MASTER_EXPORT_ACTIVE_USER = "api/v1/users/export/active";
export const API_USER_MASTER_EXPORT_ALL_USER = "api/v1/users/export/all";
export const API_USER_MASTER_DOWNLOAD_TEMPLATE =
  "api/v1/users/download-template";
export const API_USER_MASTER = "api/v1/users";
export const API_USER_MASTER_UPDATE_BATCH = "api/v1/users/batch";
export const API_USER_MASTER_CHANGE_PASSWORD = "api/v1/users/change-password";
export const API_USER_MASTER_RESET_PASSWORD = "api/v1/users/reset-password";
export const API_USER_MASTER_SEARCH = "api/v1/users/search";
export const API_USER_MASTER_DOWNLOAD_SEARCH_RESULT =
  "api/v1/users/download-search-result";

// API Machines Master
export const API_GET_MACHINE_TOP = "/api/v1/settings/page/machine-top";
export const API_MACHINE_UPDATE_SIDEBAR = "api/v1/settings/page/machine-master-update";
export const API_MACHINE_HISTORY_SEARCH_SIDEBAR = "api/v1/settings/page/machine-master-history-search";
export const API_MACHINE_IMPORT_SIDEBAR = "api/v1/settings/page/machine-master-import";
export const API_MACHINE_EXPORT_SIDEBAR = "api/v1/settings/page/machine-master-export";
export const API_GET_MACHINE_GROUP_SETTING = "api/v1/settings/page/machine-group";
export const API_MACHINE = "api/v1/machines";
export const API_MACHINE_UPDATE_DELETE = "api/v1/machines/batch";
export const API_MACHINE_GET_LOGS = "api/v1/machines/logs";
export const API_MACHINE_DOWNLOAD_LOG = "api/v1/machines/download-log";
export const API_MACHINE_DOWNLOAD_TEMPLATE = "api/v1/machines/download-template";
export const API_MACHINE_IMPORT = "api/v1/machines/import";
export const API_MACHINE_EXPORT_ALL = "api/v1/machines/export/all";
export const API_MACHINE_EXPORT_ACTIVE = "api/v1/machines/export/active";
export const API_GROUPS = "api/v1/machine-manager/groups";
export const API_GROUPS_CHILDREN = "api/v1/machine-manager/groups-children";
export const API_GROUPS_LIST = "api/v1/machine-manager/groups-list";

// API Departments Master
export const API_GET_DEPARTMENT_TOP = "/api/v1/settings/page/department-top";
export const API_GET_DEPARTMENT_SETTING = "/api/v1/settings/page/department";
export const API_GET_DEPARTMENT_UPDATE_HISTORY_SEARCH_PAGE = "api/v1/settings/page/department-master-history-search";
export const API_GET_DEPARTMENT_MASTER_IMPORT_PAGE = "api/v1/settings/page/department-master-import";
export const API_GET_DEPARTMENT_MASTER_EXPORT_PAGE = "api/v1/settings/page/department-master-export";
export const API_DEPARTMENTS = "api/v1/departments";
export const API_DEPARTMENT_GET_LOGS = "api/v1/departments/logs";
export const API_DEPARTMENT_DOWNLOAD_LOGS = "api/v1/departments/download-log";
export const API_GET_DEPARTMENT_MASTER_DOWNLOAD_TEMPLATE_PAGE = "api/v1/departments/download-template";
export const API_POST_DEPARTMENT_MASTER_IMPORT = "api/v1/departments/import";
export const API_DEPARTMENT_MASTER_EXPORT_ALL_USER = "api/v1/departments/export/all";

// API Positions Master
export const API_GET_POSITION_TOP = "/api/v1/settings/page/position-top";
export const API_POSITION_UPDATE_SIDEBAR = "api/v1/settings/page/position-master-update";
export const API_POSITION_HISTORY_SEARCH_SIDEBAR = "api/v1/settings/page/position-master-history-search";
export const API_POSITION_IMPORT_SIDEBAR = "api/v1/settings/page/position-master-import";
export const API_POSITION_EXPORT_SIDEBAR = "api/v1/settings/page/position-master-export";
export const API_POSITION = "api/v1/positions";
export const API_POSITION_DELETES = "api/v1/positions/batch";
export const API_POSITION_GET_LOGS = "api/v1/positions/logs";
export const API_POSITION_DOWNLOAD_LOG = "api/v1/positions/download-log";
export const API_POSITION_DOWNLOAD_TEMPLATE = "api/v1/positions/download-template";
export const API_POSITION_IMPORT = "api/v1/positions/import";
export const API_POSITION_EXPORT = "api/v1/positions/export/all";

// API Approval Settings Master
export const API_APPROVAL_SETTING_TOP = "/api/v1/settings/page/approval-setting-top";
export const API_GET_WORKFLOW_SETTING = "/api/v1/settings/page/workflow";
export const API_APPROVAL_SETTING_SEARCH_PAGE = "/api/v1/settings/page/approval-setting-master-history-search";
export const API_APPROVAL_SETTING_IMPORT_PAGE = "/api/v1/settings/page/approval-setting-import";
export const API_APPROVAL_SETTING_EXPORT_PAGE = "/api/v1/settings/page/approval-setting-export";
export const API_INSPECTION_WORKFLOW = "api/v1/inspection/workflows";
export const API_GET_USER_IN_TEMPLATES = "/api/v1/inspection/users-template";
export const API_GET_APPROVAL_SETTING_LOGS = "api/v1/approval-settings/logs";
export const API_APPROVAL_SETTING_DOWNLOAD_LOG = "api/v1/approval-settings/download-log";
export const API_APPROVAL_SETTING_DOWNLOAD_TEMPLATE = "api/v1/approval-settings/download-template";
export const API_APPROVAL_SETTING_IMPORT = "api/v1/inspection/workflows/import";
export const API_APPROVAL_SETTING_EXPORT = "api/v1/inspection/workflows/export";
export const API_GET_APPROVAL_SETTING_TEMPALTE =
  "api/v1/inspection/workflows/get-template";

// API Inspection Templates Master
export const API_INSPECTION_TEMPLATE_TOP = "/api/v1/settings/page/inspection-template-top";
export const API_GET_TEMPLATE_MANAGEMENT_SETTINGS = "/api/v1/settings/page/template-management";
export const API_GET_INSPECTION_ITEM_SETTINGS = "/api/v1/settings/page/edit-inspection-item";
export const API_INSPECTION_TEMPLATE_SEARCH_PAGE = "/api/v1/settings/page/inspection-template-master-history-search";
export const API_INSPECTION_TEMPLATE_IMPORT_PAGE = "/api/v1/settings/page/inspection-template-import";
export const API_INSPECTION_TEMPLATE_EXPORT_PAGE = "/api/v1/settings/page/inspection-template-export";
export const API_GET_OR_CREATE_TEMPLATE = "/api/v1/templates";
export const API_UPDATE_TEMPLATE = "/api/v1/templates/batch";
export const API_GET_OR_UPDATE_INSPECTION_ITEM = (template_id) => `/api/v1/templates/${template_id}/inspection-items`;
export const API_INSPECTION_ITEM = "/api/v1/inspection-items";
export const API_GET_INSPECTION_TEMPLATE_LOGS = "api/v1/templates/logs";
export const API_INSPECTION_TEMPLATE_DOWNLOAD_LOG = "api/v1/templates/download-log";
export const API_INSPECTION_TEMPLATE_DOWNLOAD_TEMPLATE = "api/v1/templates/download-template";
export const API_INSPECTION_TEMPLATE_IMPORT = "api/v1/templates/import";
export const API_INSPECTION_TEMPLATE_EXPORT = "api/v1/templates/export";
export const API_INSPECTION_METHOD = "/api/v1/inspection-methods";

//S6 MachineInput
export const API_GET_MACHINE_INPUT_SETTING =
  "api/v1/settings/page/machine-input";
export const API_SEARCH_MACHINES =
  "api/v1/inspection/machine-input/search-machines";
export const API_USER_SETTING =
  "api/v1/users/user-setting";
export const API_SEARCH_BY_MACHINE_NAME =
  "api/v1/inspection/machine-input/machine";

//S7 RegisterInspection
export const API_GET_REGISTER_INSPECTION_SETTING =
  "api/v1/settings/page/register-inspection-result";
export const API_REGISTER_INSPECTION = (templateId, machineId) =>
  `api/v1/inspections/register/${templateId}/${machineId}`;

export const API_REGISTER_TEMPORARY_INSPECTION = (templateId, machineId) =>
  `api/v1/inspections/temporary-inspection/${templateId}/${machineId}`;

export const API_CHANGE_MACHINE_TEMPLATE = (templateId) =>
  `api/v1/inspections/change-machine-template/${templateId}`;

//S8 UpdateInspection
export const API_GET_UPDATE_INSPECTION_SETTING =
  "api/v1/settings/page/update-inspection-result";
export const API_UPDATE_INSPECTION = (inspectionId) =>
  `api/v1/inspections/update/${inspectionId}`;
export const API_CHANGE_MACHINE_INSPECTION = (inspectionId) =>
  `api/v1/inspections/change-machine-inspection/${inspectionId}`;

// S16 Unfinished
export const API_GET_UNFINISHED_SETTING =
  "api/v1/settings/page/unfinished-action-list";
export const API_GET_UNFINISHED = "api/v1/inspections/unfinished";

//S17 RegisterTreatment
export const API_GET_REGISTER_TREATMENT_SETTING =
  "api/v1/settings/page/treatment";
export const API_REGISTER_TREATMENT = (inspectionId) =>  `api/v1/treatments/register/${inspectionId}`;


//Search
export const API_GET_SEARCH_SIDEBAR = "api/v1/settings/page/search";
export const API_GET_SEARCH_MACHINE_SIDEBAR =
  "api/v1/settings/page/search-machines";
export const API_SEARCH = "api/v1/search";
export const API_GET_SEARCH_INSPECTION_SETTING =
  "api/v1/settings/page/search-inspections";
export const API_GET_SEARCH_INSPECTION_HISTORY_RESULT =
  "api/v1/search/inspections";
export const API_GET_SEARCH_HISTORY_TREATMENT_DETAIL = (
  workflow_id,
  treatment_id
) => `/api/v1/treatments/history/${workflow_id}/${treatment_id}`;
export const API_SEARCH_MACHINES_SEARCH = "api/v1/search/machines";
export const API_SEARCH_EXPORT_MACHINES = "api/v1/search/export/machines";

//S15-1-2 Search Inspection History Confirm
export const API_SEARCH_INSPECTION_HISTORY_CONFIRM = (
  workflowId,
  inspectionId,
  queryParams = {}
) => {
  const queryString = new URLSearchParams(queryParams).toString();
  let url = `api/v1/search/inspections/confirmation/${workflowId}/${inspectionId}`;
  if (queryString) {
    url += `?${queryString}`;
  }
  return url;
};
export const API_EXPORT_INSPECTION_CONFIRM = (workflowId, inspectionId) =>
  `api/v1/search/inspections/confirmation-export/${workflowId}/${inspectionId}`;
export const API_CANCEL_INSPECTION = (inspectionId) =>
  `api/v1/search/inspections/cancel/${inspectionId}`;

//S15-1-3 Search Inspection History Correction
export const API_SEARCH_INSPECTION_HISTORY_CORRECTION = (
  workflowId,
  inspectionId
) => `api/v1/search/inspections/correction/${workflowId}/${inspectionId}`;

export const API_SEARCH_INSPECTION_EXPORT = (params = {}) => {
  let url = "api/v1/search/inspections/export";
  if (params) {
    url += `?${params}`;
  }
  return url;
};

//S39 Inspection Sheet
export const API_GET_INSPECTION_SHEET_SETTING = "api/v1/settings/page/inspection-sheet";
export const API_GET_INSPECTION_SHEET = "api/v1/inspections/sheet";
export const API_INSPECTION_SHEET_DOWNLOAD = "api/v1/inspections/sheet/export";

// S40 inspection status
export const API_GET_INSPECTION_STATUS = "/api/v1/status/inspections";
export const API_GET_JUDGMENT_STATUS = "/api/v1/status/judgment";
export const API_INSPECTION_STATUS_DETAIL = "/api/v1/status/inspection-detail";
export const API_INSPECTION_STATUS_DOWNLOAD = "/api/v1/status/inspections/export";

export const API_COMMENT_FILE_DETAIL = (dataId) =>
  `api/v1/inspections/get-comment-file/${dataId}`;
